"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Retrieves the correct auth driver for this tenant
 * @param {MidCore} mid - the mid core login
 * @param {LoginInfo} loginInfo - the login to get a driver for
 * @return {AuthDriver} - the auth driver for this tenant
 * @throws {Error} - if no auth driver exists for this tenant
 */
var _default = function _default(mid, loginInfo) {
  var driver = mid.driverFor(loginInfo.authDriver);

  if (!driver) {
    throw new Error(mid.errors.ERR_MISSING_AUTH_DRIVER("Missing auth driver \"".concat(loginInfo.authDriver, "\"")));
  } else {
    return driver;
  }
};

exports["default"] = _default;